export default __webpack_public_path__ + "static/media/manifestations_boris-johson_police.65841f92.jpg";